(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clubborne-brand-stats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clubborne-brand-stats')) {
    customElements.define(
      'clubborne-brand-stats',
      class extends HTMLElement {
        connectedCallback() {
          this.frames = new Set();
          if (
            this.dataset.animate !== 'true' ||
            window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
            !('IntersectionObserver' in window)
          )
            return;

          this.classList.add('stats-animated');
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const item = entry.target;
                item.classList.add('is-visible');
                this.observer.unobserve(item);
                const counter = item.querySelector('[data-stats-count]');
                if (counter)
                  this.animateCounter(counter, parseFloat(item.style.getPropertyValue('--stats-delay')) || 0);
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
          );

          this.querySelectorAll('[data-stats-reveal]').forEach((item) => this.observer.observe(item));
        }

        animateCounter(counter, delay) {
          const target = Number(counter.dataset.statsCount);
          if (!Number.isFinite(target)) return;
          const decimals = Math.min((String(target).split('.')[1] || '').length, 6);
          const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
          });
          const duration = Math.max(300, Number(this.dataset.duration) || 1300);
          const start = performance.now() + delay;
          counter.textContent = formatter.format(0);

          const queue = () => {
            const id = requestAnimationFrame((now) => {
              this.frames.delete(id);
              if (!this.isConnected) return;
              const progress = Math.min(Math.max((now - start) / duration, 0), 1);
              const eased = 1 - Math.pow(1 - progress, 3);
              const value = decimals ? target * eased : Math.trunc(target * eased);
              counter.textContent = formatter.format(progress === 1 ? target : value);
              if (progress < 1) queue();
            });
            this.frames.add(id);
          };
          queue();
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.frames) this.frames.forEach((id) => cancelAnimationFrame(id));
          this.classList.remove('stats-animated');
          this.querySelectorAll('[data-stats-count]').forEach((counter) => {
            counter.textContent = counter.dataset.statsCount;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clubborne-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clubborne-collections')) {
    customElements.define('clubborne-collections', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.animate !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.classList.add('collections-animated');
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
        this.querySelectorAll('[data-collection-reveal]').forEach((item) => this.observer.observe(item));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.classList.remove('collections-animated');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fall-event-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clubborne-event-countdown')) {
    customElements.define(
      'clubborne-event-countdown',
      class extends HTMLElement {
        connectedCallback() {
          const rawEnd = this.dataset.endAt || '';
          if (!rawEnd) return;
          const end = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(rawEnd)
            ? Date.parse(rawEnd)
            : NaN;
          if (!Number.isFinite(end)) {
            if (this.dataset.designMode !== 'true') this.hidden = true;
            return;
          }

          const fields = ['days', 'hours', 'minutes', 'seconds'].map((unit) =>
            this.querySelector(`[data-countdown-${unit}]`)
          );

          const update = () => {
            const remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
            if (remaining === 0) {
              this.hidden = true;
              clearInterval(this.countdownInterval);
              return;
            }

            const values = [
              Math.floor(remaining / 86400),
              Math.floor((remaining % 86400) / 3600),
              Math.floor((remaining % 3600) / 60),
              remaining % 60,
            ];

            fields.forEach((field, index) => {
              if (field) field.textContent = String(values[index]).padStart(2, '0');
            });
          };

          update();
          if (!this.hidden) this.countdownInterval = setInterval(update, 1000);
        }

        disconnectedCallback() {
          clearInterval(this.countdownInterval);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
